import { Component, Input } from '@angular/core';
import { TreeListItem } from '../../interfaces/tree-list-item.model';

@Component({
  selector: 'app-tree-list',
  templateUrl: './tree-list.component.html',
  styleUrls: ['./tree-list.component.scss']
})
export class TreeListComponent {
  @Input() list: TreeListItem[];
  @Input() external: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/components/tree-list/tree-list.component.ts